module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep7-5934c96bf1da02f03c3e61d976230ea8.wav";